import { render, staticRenderFns } from "./QScroll.vue?vue&type=template&id=0c36933b&scoped=true&"
import script from "./QScroll.vue?vue&type=script&lang=js&"
export * from "./QScroll.vue?vue&type=script&lang=js&"
import style0 from "./QScroll.vue?vue&type=style&index=0&id=0c36933b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36933b",
  null
  
)

export default component.exports